module.exports = __webpack_public_path__ + "7087d5e1b438776d6b92f406081482fa.png";